const profileReducer = (
  state = {
    loading: false,
    data: null
  },
  action
) => {
  switch (action.type) {
    case "SET_PROFILE_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "SET_PROFILES":
      return {
        ...state,
        data: action.payload,
      };

    case "RESET":
      return {
        loading: false,
        data: null
      };

    default:
      return state;
  }
};
export default profileReducer;
